import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {RootState} from '../../reducers/rootReducer';
import utils from '../../helpers/utils';
import {reapplyExperimentVariants, setExperimentUser} from '../../helpers/amplitudeExperiment';

/**
 * Identifies the logged-in member to Amplitude Experiment and re-applies
 * visual variants on hash-route changes (DSP is a HashRouter SPA).
 */
export function useAmplitudeExperimentIdentity(): void {
  const auth = useSelector((store: RootState) => store.auth);
  const location = useLocation();
  const userId =
    utils.safeGet(auth, 'user.primaryMember.accountGuid', '') ||
    utils.safeGet(auth, 'user.primaryMember.nortonGuid', '');
  const countryCode = utils.safeGet(auth, 'user.countryCode', '');
  const planName = utils.safeGet(auth, 'user.primaryMember.plan.name', '');

  useEffect(() => {
    const deviceId = utils.getGenIdFromGdIdCookie();
    if (!userId && !deviceId) {
      return;
    }

    const userProperties: Record<string, unknown> = {};
    if (countryCode) {
      userProperties.country = countryCode;
    }
    if (planName) {
      userProperties.plan_name = planName;
    }
    userProperties.current_page = location.pathname;
    setExperimentUser({
      user_id: userId || undefined,
      device_id: deviceId || undefined,
      user_properties: Object.keys(userProperties).length > 0 ? userProperties : undefined,
    });
  }, [userId, countryCode, planName, location.pathname]);

  useEffect(() => {
    reapplyExperimentVariants();
  }, [location.pathname]);
}
